export default __webpack_public_path__ + "static/media/placeholder_dummy2016-yoga01-de.89faac1d.png";